import { BASE_URL, UPLOAD_ROOT_PATH } from "./Constants";

export const image_url = (path) => {
    if (path.includes("http://") || path.includes("https://")) {
        return path;
    } else {
        return `${BASE_URL}/${path.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replaceAll("public/","")}`;
    }
}